/**
 * Program Categories slice
 */

import { createAction, createSlice } from '@reduxjs/toolkit';
import { Category } from '../../store/slices/types';

const initialState = {
  categories: [] as Category[],
  currentCategory: null as Category | null,
  loading: false,
  error: null as string | null,
};

const programCategoriesSlice = createSlice({
  name: 'programCategories',
  initialState,
  reducers: {
    setCategories(state, action) {
      state.categories = action.payload;
      state.loading = false;
      state.error = null;
    },
    setCurrentCategory(state, action) {
      state.currentCategory = action.payload;
      state.loading = false;
      state.error = null;
    },
    addCategory(state, action) {
      state.categories.push(action.payload);
      state.loading = false;
      state.error = null;
    },
    updateCategory(state, action) {
      const index = state.categories.findIndex(
        (c) => (c._id || c.id) === (action.payload._id || action.payload.id)
      );
      if (index !== -1) {
        state.categories[index] = action.payload;
      }
      if (state.currentCategory && (state.currentCategory._id || state.currentCategory.id) === (action.payload._id || action.payload.id)) {
        state.currentCategory = action.payload;
      }
      state.loading = false;
      state.error = null;
    },
    removeCategory(state, action) {
      state.categories = state.categories.filter(
        (c) => (c._id || c.id) !== action.payload
      );
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

// Reducer
export const programCategoriesReducer = programCategoriesSlice.reducer;

// Actions
export const {
  setCategories,
  setCurrentCategory,
  addCategory,
  updateCategory,
  removeCategory,
  setLoading,
  setError,
  clearError,
} = programCategoriesSlice.actions;

// Async Actions
export const fetchProgramCategories = createAction('PROGRAM_CATEGORIES/FETCH_ALL');
export const fetchProgramCategory = createAction<string>('PROGRAM_CATEGORIES/FETCH_ONE');
export const createProgramCategory = createAction<Omit<Category, '_id' | 'id'>>('PROGRAM_CATEGORIES/CREATE');
export const updateProgramCategoryAction = createAction<{ id: string; data: Partial<Category> }>('PROGRAM_CATEGORIES/UPDATE');
export const deleteProgramCategory = createAction<string>('PROGRAM_CATEGORIES/DELETE');

